import {
  LOANS_FETCHED,
  FETCH_BEGIN,
  FETCH_END
} from "utils/constants";
// import asyncDispatcher from 'utils/asyncDispatcher';

// export const fetchLoansByOrg = (orgId) => (dispatch, getState) => {
//   const { api } = getState().app;

//   return asyncDispatcher(dispatch, {
//     action: api.fetchLoansByOrg(orgId),
//     data: { orgId },
//     pending: ORG_LOANS_FETCH_REQUESTED,
//     success: ORG_LOANS_FETCHED,
//     failure: ORG_LOANS_FETCH_FAILED
//   });
// };

export const fetchLoans = (params={}) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: FETCH_BEGIN});

  api.fetchLoans(params)
    .then(data => {
      dispatch({
        type: LOANS_FETCHED,
        data: { loans: data.loans || data }
      });
      dispatch({type: FETCH_END});
    });
};

// export const fetchLoanReminders = () => (dispatch, getState) => {
//   const { api } = getState().app;

//   return asyncDispatcher(dispatch, {
//     pending: LOANS_FETCH_REQUESTED,
//     action: api.fetchLoanReminders(),
//     success: LOANS_FETCHED,
//     failure: LOANS_FETCH_FAILED
//   });
// };

// export const confirmRepayment = (loanScheduleId, status) => (dispatch, getState) => {
//   const { api } = getState().app;
//   dispatch({type: TOGGLE_SPINNER});

//   api.confirmRepayment(loanScheduleId, status)
//     .then(resp => {
//       dispatch(fetchLoanReminders());
//     })
//     .then(() => { dispatch({type: TOGGLE_SPINNER}) })
// };

// export const noteLoanSchedule = (loanScheduleId, note) => (dispatch, getState) => {
//   const { api } = getState().app;
//   dispatch({type: TOGGLE_SPINNER});
//   api.noteLoanSchedule(loanScheduleId, note)
//     .then(resp => {
//       dispatch(fetchLoanReminders());
//     })
//     .then(() => { dispatch({type: TOGGLE_SPINNER}) })
// };

// export const notifyCustomer = (loanScheduleId) => (dispatch, getState) => {
//   const { api } = getState().app;
//   dispatch({type: TOGGLE_SPINNER});
//   api.notifyCustomer(loanScheduleId)
//     .then(resp => {
//       dispatch(fetchLoanReminders());
//     })
//     .then(() => { dispatch({type: TOGGLE_SPINNER}) })
// };

// export const updateLoan = (loanId, payload) => (dispatch, getState) => {
//   const { api } = getState().app;
//   dispatch({type: TOGGLE_SPINNER});

//   api.updateLoan(loanId, payload)
//     .then(resp => {
//       dispatch({type: TOGGLE_NOTIFICATION, data: { notificationMsg: `${resp.loan.loanNumber} has been updated`}});
//       dispatch(fetchLoans());
//     })
// };



// WEBPACK FOOTER //
// ./src/actions/loans.js